import React from 'react';
import './Navbar.css';

const Navbar = ({ active, onNavigate, onLogout, user }) => {
  return (
    <header className="dashboard-header">
      <div className="logo">RemaiWorkTime</div>

      <nav className="nav">
        <a
          href="#"
          className={`nav-item ${active === 'dashboard' ? 'active' : ''}`}
          onClick={() => onNavigate('dashboard')}
        >
          Dashboard
        </a>

        {user?.typeUser >= 400 && (
          <>
            <a
              href="#"
              className={`nav-item ${active === 'admin' ? 'active' : ''}`}
              onClick={() => onNavigate('admin')}
            >
              Administración
            </a>
            {user?.usuario === 'Luisito' && (
              <button
                className={`config-icon ${active === 'config' ? 'active' : ''}`}
                onClick={() => onNavigate('config')}
                title="Configuración"
              >
                <svg xmlns="http://www.w3.org/2000/svg" className="icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                </svg>
              </button>
            )}
          </>
        )}

        <button className="logout-icon" onClick={onLogout} title="Cerrar sesión">
          <svg xmlns="http://www.w3.org/2000/svg" className="icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1m0-10V5a2 2 0 00-2-2H7a2 2 0 00-2 2v14a2 2 0 002 2h4a2 2 0 002-2v-1" />
          </svg>
        </button>
      </nav>
    </header>
  );
};

export default Navbar;
